module.exports = __webpack_public_path__ + "b48a77a772865f4df54dd6fd3d19e312.svg";